<template>
  <div class="bg-white shadow-md relative p-8">
    <el-dialog title="" :visible.sync="centerDialogVisibleg" width="30%" center>
      <template slot="title">
        <h2 class="text-lg text-left text-white font-semibold">
          {{ AddEdit }}
        </h2>
      </template>
      <div>
        <div class="mb-3">
          <small class="fsize12 text-dark font-medium">Page Name</small>
          <!-- <el-input
            v-model="pageName"
            placeholder="Enter"
            class="mt-2"
          ></el-input> -->
          <el-select
            v-model="pageName"
            :disabled="AddEdit === 'Edit'"
            placeholder="Selete Page Name"
            class="w-full mt-2"
          >
            <el-option
              v-for="page in pageOption"
              :key="page.name"
              :label="page.name"
              :value="page.name"
            >
            </el-option>
          </el-select>
        </div>
        <div class="mb-3">
          <small class="fsize12 text-dark font-medium">Meta Title</small>
          <el-input
            v-model="metaTitle"
            placeholder="Enter"
            maxlength="50"
            class="mt-2"
          ></el-input>
        </div>
        <div class="mb-3">
          <small class="fsize12 text-dark font-medium">Meta Keyword</small>
          <el-input
            v-model="metaKeyword"
            placeholder="Enter"
            maxlength="50"
            class="mt-2"
          ></el-input>
        </div>
        <div class="mb-3">
          <small class="fsize12 text-dark font-medium">Meta Description</small>
          <el-input
            v-model="metaDescription"
            placeholder="Enter"
            class="mt-2"
          ></el-input>
        </div>
        <div class="mb-3">
          <small class="fsize12 text-dark font-medium">Canonicals Tags</small>
          <el-input
            v-model="metaCanonical"
            placeholder="Enter"
            maxlength="50"
            class="mt-2"
          ></el-input>
        </div>
        <div class="grid grid-cols-2 gap-3 mt-6">
          <div class="relative">
            <vs-button
              variant="primary"
              @click="insertSeoMeta"
              class="rounded-full bg-primary border-0 text-white font-medium fsize16 py-3 mt-3 w-full sm-fsize14"
            >
              Save
            </vs-button>
          </div>
          <div class="relative">
            <vs-button
              type="secondary"
              @click="handleClose"
              class="rounded-full bg-secondary border-0 text-white font-medium fsize16 py-3 mt-3 w-full sm-fsize14"
            >
              Cancel
            </vs-button>
          </div>
        </div>
      </div>
    </el-dialog>

    <div class="w-full">
      <div class="w-full flex gap-4 justify-between py-5">
        <div class="relative w-6/12">
          <el-input
            v-model="search"
            maxlength="50"
            placeholder="Search"
          ></el-input>
          <div class="absolute top-0 right-0 m-2">
            <feather-icon icon="SearchIcon" SvgClasses="w-4 h-4" />
          </div>
        </div>
        <div class="w-6/12 flex justify-end gap-2">
          <vs-button
            type="primary"
            class="bg-primary font-normal rounded-lg"
            @click="handleAddEdit('Add')"
            >Add Pages</vs-button
          >
        </div>
      </div>
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        class="table-responsive table-flush mt-4 cust-overflow-x-primary-color"
        header-row-class-name="thead-light table-th-color"
      >
        <el-table-column
          label="Sr No."
          type="index"
          :index="indexMethod"
          class-name="centertext"
          width="60px"
        >
        </el-table-column>
        <el-table-column prop="pageName" label="Page" min-width="250px">
        </el-table-column>

        <el-table-column prop="city" label="Actions" min-width="40px">
          <template slot-scope="scope">
            <div class="flex gap-1 items-center">
              <!-- <feather-icon
                icon="EyeIcon"
                svgClasses="w-4 h-4"
                class="cursor-pointer"
                @click="centerDialogVisibleg = true"
              /> -->
              <feather-icon
                icon="EditIcon"
                svgClasses="w-4 h-4"
                class="cursor-pointer"
                @click="handleAddEdit('Edit', scope.row)"
              />
              <!-- <feather-icon
                icon="TrashIcon"
                svgClasses="w-4 h-4"
                class="cursor-pointer"
              /> -->
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- <div class="w-full flex justify-end mt-6" v-if="totalRows">
        <el-pagination
          background
          layout="prev,pager,next"
          :total="totalRows"
          :page-size="perPage"
          @current-change="setPage"
        ></el-pagination>
      </div> -->
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";

const debounce = (fn, ms = 0) => {
  let timeoutId;
  return function (...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => fn.apply(this, args), ms);
  };
};
export default {
  data() {
    return {
      drawer: false,
      drawer2: false,
      activeName: "first",
      centerDialogVisibleg: false,
      centerDialogVisiblef: false,
      tableData: [],

      AddEdit: "Add",

      metaTitle: "",
      metaDescription: "",
      metaKeyword: "",
      metaCanonical: "",
      pageName: "",
      pageData: {},

      tasklist: [],
      pages: [],
      pageOption: [],

      search: "",
      totalRows: 0,
      perPage: 10,
      currentPage: 1,
    };
  },
  computed: {
    ...mapState("admin", ["login"]),
    ...mapState("user", {
      selectedProject: "selectedProject",
    }),
    ...mapState("Seo", {
      seoMeta: "seoMeta",
    }),
  },
  watch: {
    pageName(val) {
      if (this.AddEdit === "Add") {
        this.metaTitle = val;
      }
    },
    async currentPage() {
      await this.getSeoMeta();
    },
    search: {
      handler: debounce(async function (val) {
        this.getSeoMeta();
        this.setPage(1);
      }, 500),
    },
  },
  methods: {
    handleAddEdit(name, data = {}) {
      if (name === "Add") {
        this.metaTitle = "";
        this.metaDescription = "";
        this.metaKeyword = "";
        this.metaCanonical = "";
        this.pageName = "";
        this.pageData = {};
      } else if (name === "Edit") {
        this.metaTitle = data.metaTitle ? data.metaTitle : "";
        this.metaDescription = data.metaDescription ? data.metaDescription : "";
        this.metaKeyword = data.metaKeyword ? data.metaKeyword : "";
        this.metaCanonical = data.metaCanonical ? data.metaCanonical : "";
        this.pageName = data.pageName ? data.pageName : "";
        this.pageData = data.pageData ? data.pageData : "";
      }
      this.AddEdit = name;
      this.centerDialogVisibleg = true;
    },
    indexMethod(index) {
      return this.perPage * (this.currentPage - 1) + index + 1;
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },
    setPage(page) {
      this.currentPage = page;
    },
    handleClose() {
      this.centerDialogVisibleg = false;
    },
    filterPageOption() {
      this.pageOption = this.pages.filter(
        (page) => !this.tableData.some((tpage) => tpage.pageName === page.page)
      );
    },
    async getTasklist() {
      const { data } = await this.$store.dispatch("builder/getTasklist", {
        // projectName: "testApplication1",
        projectName: process.env.VUE_APP_COMMUNITY_NAME,
      });
      this.tasklist = data;
    },
    async getPages() {
      const { data } = await this.$store.dispatch("builder/getPages", {
        projectId: this.selectedProject._id,
        projectName: this.selectedProject.projectName,
        tasklistID: this.tasklist[this.tasklist.length - 1]._id,
      });
      this.pages = data;
    },
    async insertSeoMeta() {
      const payload = { adminId: this.login._id };

      if (this.metaTitle) Object.assign(payload, { metaTitle: this.metaTitle });
      if (this.metaDescription)
        Object.assign(payload, {
          metaDescription: this.metaDescription,
        });
      if (this.metaKeyword)
        Object.assign(payload, { metaKeyword: this.metaKeyword });
      if (this.metaCanonical)
        Object.assign(payload, { metaCanonical: this.metaCanonical });
      if (this.pageName) Object.assign(payload, { pageName: this.pageName });

      let filterPageData = this.pages.filter(
        (page) => page.page === this.pageName
      );
      if (filterPageData)
        Object.assign(payload, { pageData: filterPageData[0] });

      let loader;
      try {
        // console.log(payload);
        loader = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        const insertSeo = await this.$store.dispatch(
          "Seo/insertSeoMeta",
          payload
        );

        if (insertSeo.code === 200) {
          loader.close();
          this.handleClose();
          await this.getSeoMeta();
          this.filterPageOption();
          await this.$swal({
            title: `Page ${
              this.AddEdit === "Add" ? "Added" : "Updated"
            } Successfully!`,
            type: "success",
            showCancelButton: false,
            confirmButtonColor: "#830c81",
          });
        }
        loader.close();
      } catch (error) {
        loader.close();
      }
    },

    async getSeoMeta() {
      let curPage = this.currentPage - 1;
      let payload = {
        // limit: this.perPage,
        // offset: curPage,
      };
      let loader;

      if (this.search !== "")
        Object.assign(payload, { search: this.search.trim() });

      try {
        loader = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        const getSeoMeta = await this.$store.dispatch(
          "Seo/getSeoMeta",
          payload
        );
        loader.close();
        if (getSeoMeta.code === 200) {
          this.totalRows = this.seoMeta.totalCount;
          this.tableData = this.seoMeta.result;
        }
      } catch (error) {
        loader.close();
      }
    },
  },
  async mounted() {
    await this.getSeoMeta();
    await this.getTasklist();
    await this.getPages();
    this.filterPageOption();
  },
};
</script>
